import React, { Fragment, useEffect } from 'react' 
import {  Link, useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap'
import {Navbar, Nav, Container, NavDropdown, Img, Button, DropdownButton, Dropdown, Card } from 'react-bootstrap'

const Header = () => {

    const dispatch = useDispatch()
    const history = useNavigate();


    useEffect(() => {


    }, [])

    const navigateToHome = () => {
        history.push('/')
    }

    const navigateToGithub = () => {
        window.open('https://github.com/pixagan/laeyerz', '_blank')
    }

    return (
        <header className="header" style={{border:'None', marginBottom:'0px', borderLeft:'None', borderRight:'None', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',paddingBottom:'0px'}}>

            <Navbar expand="lg" collapseOnSelect style={{padding:'0px', borderColor:'#b861fb'}}>
                
                <Container>
                <LinkContainer to='/'>
                    <>
                

                        <Link to='/'>
                        {/* <img src={"laeyerz_logo.png"} alt="Laeyerz" style={{ width: '30px', height: '30px' }} /> */}
                            <h5 style={{fontFamily:"Baskervville", fontSize:'2rem', color:"white",textTransform:'none'}}>Laeyerz</h5>  
                        </Link>
                 

                    </>

                </LinkContainer>

                
                <Navbar.Toggle aria-controls="basic-navbar-nav" />



                <Navbar.Collapse id="basic-navbar-nav">

                <Nav className="justify-content-center w-100" style={{ flex: 1 }}>


   
                    

                    <LinkContainer to='/docs/getting-started'>
                        <Nav.Link className='navbarlink'><Button style={{  margin:'1px', paddingTop:'5px', paddingBottom:'5px', borderRadius:'20px', backgroundColor:'white', color:'black',  border:'None', borderColor:'#c2179a', fontSize: '1.2rem',fontFamily:"Baskervville", textTransform:'none' }}>Docs</Button></Nav.Link>
                    </LinkContainer>

                    <LinkContainer to='/examples'>
                        <Nav.Link className='navbarlink'><Button style={{  margin:'1px', paddingTop:'5px', paddingBottom:'5px', borderRadius:'20px', backgroundColor:'white', color:'black',  border:'None', borderColor:'#c2179a', fontSize: '1.2rem',fontFamily:"Baskervville", textTransform:'none' }}>Examples</Button></Nav.Link>
                    </LinkContainer>

                    {/* <LinkContainer to='/nodes'>
                        <Nav.Link className='navbarlink'><Button style={{  margin:'1px', paddingTop:'5px', paddingBottom:'5px', borderRadius:'20px', backgroundColor:'white', color:'black',  border:'None', borderColor:'#c2179a', fontSize: '1.2rem',fontFamily:"Baskervville" }}>Nodes</Button></Nav.Link>
                    </LinkContainer> */}

                    
                    <Nav.Link className='navbarlink'><Button style={{  margin:'1px', paddingTop:'5px', paddingBottom:'5px', borderRadius:'20px', backgroundColor:'white', color:'black',  border:'None', borderColor:'#c2179a', fontSize: '1.2rem',fontFamily:"Baskervville", textTransform:'none' }} onClick={()=>navigateToGithub()}>Github</Button></Nav.Link>
                   
                    {/* <LinkContainer to='/flowview'>
                        <Nav.Link className='navbarlink'><Button style={{  margin:'1px', paddingTop:'5px', paddingBottom:'5px', borderRadius:'20px', backgroundColor:'white', color:'black',  border:'None', borderColor:'#c2179a', fontSize: '1.2rem',fontFamily:"Baskervville", textTransform:'none' }}>FlowView</Button></Nav.Link>
                    </LinkContainer> */}

                

                </Nav>

            </Navbar.Collapse> 


            </Container>

        </Navbar>

        </header>
    )
}

export default Header